import type { Unsubscribe } from '@amazon/vinyl-util'
import { installLazily } from '@/core/installLazily'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('installAppLinksLazy')

/** {@link installAppLinks}, loaded off the boot chunk. */
export function installAppLinksLazy(): Unsubscribe {
    return installLazily(import('@/appLinks/appLinks'), (m) => m.installAppLinks(), errorHandler)
}
